import React from 'react';
import {SVGProps} from '~/src/components/svg/SVGProps';

const SpeechBubble = ({title, primaryClassName, secondaryClassName, tertiaryClassName}: SVGProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
        {title && <title>{title}</title>}
        <path className={primaryClassName} d="M14.65 23L11 25.92V23H7V9h6V7H5v18h4v4h1.35l5-4H27v-2H14.65z" />
        <path className={tertiaryClassName} d="M25 16h2v5h-2z" />
        <path className={secondaryClassName} d="M25 9v7h2V7H13v2h12z" />
        <path
            className={primaryClassName}
            d="M16 14.5a1.5 1.5 0 1 0 1.5 1.5 1.5 1.5 0 0 0-1.5-1.5zM11.5 14.5A1.5 1.5 0 1 0 13 16a1.5 1.5 0 0 0-1.5-1.5zM20.5 14.5A1.5 1.5 0 1 0 22 16a1.5 1.5 0 0 0-1.5-1.5z"
        />
    </svg>
);

export default SpeechBubble;
